module.exports = __webpack_public_path__ + "static/img/equityImg1.png";